const IST_OFFSET_MINUTES = 5.5 * 60;

function parseServerExpiry(expiryTime) {
  if (!expiryTime) return null;

  const trimmed = expiryTime.trim();

  const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(trimmed);
  if (hasTimezone) {
    const d = new Date(trimmed);
    return isNaN(d.getTime()) ? null : d;
  }

  const normalized = trimmed.replace(" ", "T").split(".")[0]; // strip fractional seconds
  const match = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/
  );
  if (!match) return null;

  const [year, month, day, hour, minute, second] = match.slice(1).map(Number);

  const utcMs =
    Date.UTC(year, month - 1, day, hour, minute, second) -
    IST_OFFSET_MINUTES * 60 * 1000;

  return new Date(utcMs);
}

export function startExpiryChecker(expiryTime, onExpired) {
  if (!expiryTime) return null;

  try {
    const expiryDate = parseServerExpiry(expiryTime);
    if (!expiryDate || isNaN(expiryDate.getTime())) throw new Error("Invalid date");

    const checkNow = () => {
      const now = Date.now();
      const expiryMs = expiryDate.getTime();

      if (expiryMs <= now) {
        cleanup();
        onExpired();
        return;
      }

      const msLeft = expiryMs - now;
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(() => {
        checkNow();
      }, Math.min(msLeft, 30000));
    };

    let timerId = null;

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkNow();
      }
    };

    const onFocus = () => {
      checkNow();
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("focus", onFocus);

    const cleanup = () => {
      if (timerId) clearTimeout(timerId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("focus", onFocus);
    };

    checkNow();

    return { timerId: () => timerId, cleanup };

  } catch (err) {
    console.error("Expiry checker failed:", err);
    return null;
  }
}

export function clearExpiryChecker(checkerRef) {
  if (!checkerRef) return;
  // Old style (just a timeout ID) backward compatible
  if (typeof checkerRef === "number") {
    clearTimeout(checkerRef);
  } else if (checkerRef?.cleanup) {
    checkerRef.cleanup();
  }
}